export default ($resource) => {
    const url = `${SEED_CORE.ENV.API_URL}evaluation/evaluation-group-evaluation/`;

    return $resource(url, null, {
        evaluableGrouped: {
            method: 'GET',
            isArray: true,
            url: `${url}evaluable-grouped/`
        },
        evaluatorGrouped: {
            method: 'GET',
            isArray: true,
            url: `${url}evaluator-grouped/`
        },
        report: {
            method: 'GET',
            url: `${url}report/`
        }
    });
};



// WEBPACK FOOTER //
// ./src/app/resources/EvaluationGroup/Evaluation/index.js